import type { IconProps } from './IconProps';

export const LinkedInIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.91667 1C2.30608 1 1 2.30608 1 3.91667V12.0833C1 13.6939 2.30608 15 3.91667 15H12.0833C13.6945 15 15 13.6939 15 12.0833V3.91667C15 2.30608 13.6945 1 12.0833 1H3.91667ZM5.66667 12.0833H3.91667V5.66667H5.66667V12.0833ZM4.79167 4.927C4.22817 4.927 3.77083 4.46617 3.77083 3.898C3.77083 3.32983 4.22817 2.869 4.79167 2.869C5.35517 2.869 5.8125 3.32983 5.8125 3.898C5.8125 4.46617 5.35575 4.927 4.79167 4.927ZM10.9167 12.0833H12.6667V8.14058C12.6667 5.07633 9.39767 5.18775 8.58333 6.69625V5.66667H6.83333V12.0833H8.58333V8.81433C8.58333 6.99842 10.9167 6.84967 10.9167 8.81433V12.0833Z"
      fill="currentColor"
    />
  </svg>
);
